<script lang="ts">
  const { color = 'currentColor', size = 24 }: { color?: string; size?: number | string } = $props();
</script>
<svg
   viewBox="0 0 24 24"
   width={size}
   height={size}
   {color}
>
  <path
     d="m 6.663822,2.2538221 c -0.9374,-0.8027685 -2.212768,0.4726004 -1.41,1.41 l 3.14,3.09 -0.76,0.95 -1.940001,4.9999999 c -0.201844,0.538536 -0.06873,1.145396 0.34,1.55 l 3.09,3.09 c 0.59619,0.558821 1.52381,0.558821 2.12,0 l 4.600001,-4.6 c 0.264262,-0.264747 0.408778,-0.626037 0.4,-1 l 0.5,-6.4399999 h -1.07 c -0.281063,-0.00991 -0.553308,0.098985 -0.75,0.3 l -0.14,0.17 -1.05,3.48 m 0,12.7099999 5.66,-5.64 -2.12,-2.12 -5.660001,5.66"
     fill='currentColor'
     stroke='grey'
     stroke-width={1}
   />
</svg>
